import { Button } from 'antd';
import styled from 'styled-components';

import { GreenColors, NeutralColors } from '@/theme';

/**
 * Standard "Add" action button: no background at rest, green background on
 * hover (same green as the Save button), matching the Variety Deviation
 * `Add Condition` pattern.
 */
export const AddButtonStyled = styled(Button)<{ $filled: boolean }>`
  &:not(:disabled):not(.ant-btn-disabled) {
    background-color: ${({ $filled }) =>
      $filled ? GreenColors[60] : 'transparent'};
    border-color: ${({ $filled }) =>
      $filled ? GreenColors[60] : 'transparent'};
    box-shadow: none;
    border-radius: ${({ $filled }) => ($filled ? '999px' : undefined)};
    color: ${({ $filled }) => ($filled ? NeutralColors[0] : undefined)};
    height: ${({ $filled }) => ($filled ? '32px' : undefined)};
    padding-inline: ${({ $filled }) => ($filled ? '12px' : undefined)};

    &:hover {
      background-color: ${({ $filled }) =>
        $filled ? GreenColors[70] : GreenColors[60]};
      border-color: ${({ $filled }) =>
        $filled ? GreenColors[70] : GreenColors[60]};
      color: ${NeutralColors[0]};

      svg path {
        fill: ${NeutralColors[0]};
      }
    }

    ${({ $filled }) =>
      $filled &&
      `
        svg path {
          fill: ${NeutralColors[0]};
        }
      `}
  }
`;
